 <template>
	<div @touchstart="touchStart" @touchend="touchEnd" @touchmove="touchEnd">
		<div :class="[expansion ? 'backdrop' : '']"></div>
		<div class="title_section">
			<div class="title">
				{{ $t('menu.ongoing') }}
				<mt-badge
					v-if="orderList.length > 0"
					size="normal"
					type="error"
					class="order-count"
				>
					{{ orderList.length }}
				</mt-badge>
			</div>
			<div class="subtitle">
				{{ order.store_name || $t('order_progress.errand_send') }}
			</div>
		</div>
		<div class="trans" :style="translateY">
			<div class="progressdialog-container">
				<div class="navbar">
					<div class="slider" v-if="tabOrder && expansion">
						<ErrandOrderSlider
							v-if="tabOrder && expansion"
							:orderList="orderList"
							:currentOrderIndex="orderIndex"
							@updateOrderIndex="(index) => (orderIndex = index)"
						></ErrandOrderSlider>
					</div>
					<div
						:class="['navbar-content', !tabOrder ? 'chatroom' : '']"
						v-if="expansion"
					>
						<div v-if="tabOrder">
							<ErrandOrderBuy
								v-if="isErrandBuyOrder(order) && expansion"
								:expansion="expansion"
								:order="order"
							></ErrandOrderBuy>
							<ErrandOrderSend
								v-else-if="isErrandSendOrder(order) && expansion"
								:expansion="expansion"
								:order="order"
							></ErrandOrderSend>
						</div>
						<div v-else>
							<Chatroom
								ref="chatroom"
								:visible="!tabOrder"
								:params="chatroomParams"
								:toClientAvatar="toClientAvatar"
								:toClientName="toClientName"
							></Chatroom>
						</div>
					</div>
				</div>
			</div>
			<div class="deliver_section">
				<div
					class="flex-center pickup-code"
					v-if="
						expansion && tabOrder && isErrandBuyOrder(order) && isSendState(order)
					"
				>
					<div>
						{{
							$t('order_progress.pickup_code') +
							': ' +
							order.o2o_order_receive_code
						}}
					</div>
				</div>
				<div :class="['progressbar']" v-if="expansion && tabOrder">
					<StepProgressBar
						:states="
							states[
								isErrandBuyOrder(order) ? 'errandBuyOrder' : 'errandSendOrder'
							]
						"
						:activeValue="Number(order.order_state)"
					>
					</StepProgressBar>
				</div>
				<div
					class="flex-center matching-tips"
					v-if="
						expansion && isMatching(order) && isErrandSendOrder(order) && tabOrder
					"
				>
					<div>{{ $t('order_progress.errand_send_order.matching_deliver_full') }}</div>
				</div>
				<div class="flex-center delivery-time" v-if="expansion && tabOrder">
					<div>{{ deliveryTime }}</div>
				</div>
			</div>
			<div :class="['footer']">
				<div @click="showOrder">
					<img
						src="@/assets/image/home/tabOrderActive.svg"
						style="width: 0.9rem"
						v-if="tabOrder === true"
					/>
					<img
						src="@/assets/image/home/tabOrder.svg"
						style="width: 0.9rem"
						v-else
					/>
					<!-- <i class="icon iconfont icon-quanbudingdan1" /> -->
				</div>
				<div
					class="progress-dialog-toggle"
					@click="close_progress_dialog"
				><span :class="{ 'rotate': transform_val === 0 }">
    				<i class="cubeic-select" style="font-weight: bold;"></i>
				</span>
				</div>
				<div @click="showMessage" style="position: relative" v-if="isDelivering(order)">
					<img
						src="@/assets/image/home/tabMessageActive.svg"
						style="width: 1.3rem"
						v-if="tabOrder === false"
					/>
					<img
						src="@/assets/image/home/tabMessage.svg"
						style="width: 1.3rem"
						v-else
					/>
					<mt-badge
						v-if="unreadMessageCount > 0"
						size="normal"
						type="error"
						class="order-count"
						style="position: absolute; bottom: 1rem; right: -1rem;"
					>
						{{ unreadMessageCount }}
					</mt-badge>
				</div>
				<div v-else>
					<div style="width: 1.3rem"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ErrandOrderBuy from './util/ErrandOrderBuy.vue'
import ErrandOrderSend from './util/ErrandOrderSend.vue'
import ErrandOrderSlider from './util/ErrandOrderSlider.vue'
import Chatroom from './util/Chatroom.vue'
import StepProgressBar from '@/components/basic/step_progress_bar'
import { OrderState } from '@/const/order'
import chatRoom from '@src/util/chatroom'
import { Indicator } from 'mint-ui'
import { mapGetters, mapState } from 'vuex'

export default {
	components: {
		Chatroom,
		ErrandOrderBuy,
		ErrandOrderSend,
		ErrandOrderSlider,
		StepProgressBar
	},
	name: 'ProgressDialog',
	data() {
		return {
			tab: 'order',
			tabOrder: true,
			orderIndex: 0,
			dialogVisible: true,
			rooms: {},
			roomId: undefined,
			states: {
				errandBuyOrder: [
					{
						label: '',
						value: [OrderState.PAY, OrderState.RECEIPT]
					},
					{
						label: this.$t('order_progress.errand_buy_order.distributor_go'),
						value: [OrderState.OCCUPY]
					},
					{
						label: this.$t('order_progress.errand_buy_order.store_arrived'),
						value: [OrderState.DELIVER]
					},
					{
						label: this.$t('order_progress.errand_buy_order.delivering'),
						value: OrderState.SEND
					}
				],
				errandSendOrder: [
					{
						label: this.$t('order_progress.errand_send_order.matching_deliver'),
						value: [OrderState.PAY, OrderState.RECEIPT]
					},
					{
						label: this.$t(
							'order_progress.errand_send_order.deliver_to_shipping_address'
						),
						value: [OrderState.DELIVER, OrderState.OCCUPY]
					},
					{
						label: this.$t(
							'order_progress.errand_send_order.deliver_to_pickup_address'
						),
						value: OrderState.SEND
					}
				]
			},
			start_position: 0,
			end_position: 0,
			transform_val: -75
		}
	},
	props: {
		orderList: {
			default: function () {
				return []
			},
			type: Array
		},
		expansion: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters([
			'getUnreadCount',
			'memberInfo'
		]),
		unreadMessageCount: function () {
			return this.getUnreadCount(this.roomId, this.chatroomParams.toClientType)
		},
		containerClass: function () {
			let data = {
				container: true
			}
			return data
		},
		navbarClass: function () {
			let data = {
				navbar: true
			}
			if (this.expansion) {
				data.expand = true
			} else {
				data.fold = true
			}
			return data
		},
		chatroomParams: function () {
			if (!this.order) {
				return undefined
			}
			return {
				role: 'member',
				name: this.memberInfo.member_name,
				orderSn: this.order.order_sn || this.order.o2o_errand_order_sn,				
				orderId: Number(
					this.order.errand_order_type === 'buy'
						? this.order.order_id
						: this.order.o2o_errand_order_id
				),
				orderType: this.order.errand_order_type,
				toClientType: 'distributor'
			}
		},
		toClientName: function () {
			return this.order.o2o_distributor_realname || this.order.o2o_distributor_name
		},
		toClientAvatar: function () {
			return !this.order.o2o_distributor_avatar
				? undefined
				: this.order.o2o_distributor_avatar
		},
		deliveryTime: function () {
			const deliveryTimeBuffer = 5	// minutes
			const deliveryTime = this.order.delivery_time || 0

			// 未有外送員處理時
			if (
				this.order.order_state == OrderState.PAY ||
				this.order.order_state == OrderState.RECEIPT
			) {
				let isBuyOrder = this.isErrandBuyOrder(this.order)
				const currTime = this.$moment()
				const expectedTime = isBuyOrder? this.$moment(this.order.o2o_expected_order_time) : this.$moment.unix(this.order.o2o_errand_order_appointment_time)
				console.log(currTime, expectedTime.format('dddd HH:mm'))
				if (expectedTime.isSameOrBefore(currTime)) {
					return this.$t('order_progress.estimate', [
						deliveryTime + ' ~ ' + (deliveryTime + deliveryTimeBuffer)
					])
				} else {
					let expected_arrived_time = isBuyOrder? this.$moment(this.order.o2o_expected_arrived_time) : expectedTime
					let t_string = isBuyOrder? 'order_progress.expected_time' : 'order_progress.errand_expected_time'

					return expected_arrived_time.diff(this.$moment().startOf('day'), 'days') === 0
						? this.$t(t_string, [
								this.$t('order_progress.today') +
									expected_arrived_time.format(' HH:mm')
						  ])
						: this.$t(t_string, [
								expected_arrived_time.format('dddd HH:mm')
						  ])
				}
			}

			return this.$t('order_progress.estimate', [deliveryTime + ' ~ ' + (deliveryTime + deliveryTimeBuffer)])
		},
		order: function () {
			return this.orderList[this.orderIndex] || {store_name: null}
		},
		translateY() {
			return 'transform: translateY(' + this.transform_val + 'vh)'
		}
	},
	watch: {
		chatroomParams: {
			immediate: true,
			deep: true,
			handler: function (val) {
				this.$socket.emit('getRoomIdByOrder', val, (res) => {
					if (res.code === 0) {
						this.roomId = res.results.roomId
					}
				})
			}
		}
	},
	methods: {
		isSendState(order) {
			return Number(order.order_state) === OrderState.SEND
		},
        isDelivering(order) {
            return [OrderState.OCCUPY, OrderState.DELIVER, OrderState.SEND].some((v) => v === Number(order.order_state))
        },
		isMatching(order) {
			return [OrderState.PAY].some((v) => v === Number(order.order_state))
		},
		isErrandBuyOrder(order) {
			return order && !!order.order_id
		},
		isErrandSendOrder(order) {
			return order && !!order.o2o_errand_order_id
		},
		updateExpansion(value) {
			if (!value) {
				this.showOrder()
			}
			this.$emit('updateExpansion', value)
		},
		closeDialog() {
			this.$emit('close', this.orderIndex, this.selectedRoomUnreadCount)
		},
		showMessage() {
			this.tab = 'message'
			this.tabOrder = false
		},
		showOrder() {
			this.tab = 'order'
			this.tabOrder = true
		},
		touchStart(e) {
			this.start_position = e.changedTouches[0].screenY
		},
		touchEnd(e) {
			this.end_position = e.changedTouches[0].screenY
			this.direction()
		},
		direction() {
			if(this.start_position <= this.end_position) {
				this.transform_val = 0
				this.updateExpansion(true)
				document.getElementById('app').style.overflow = 'hidden'
			} else {
				this.transform_val = -75
				this.updateExpansion(false)
				document.getElementById('app').style.overflow = 'scroll'
			}
		},
		close_progress_dialog() {
			if(this.transform_val === 0) {
				this.transform_val = -75
				this.updateExpansion(false)
				document.getElementById('app').style.overflow = 'scroll'
			}
		}
	}
}
</script>
<style lang='scss' scoped>
$foldBgColor: #f4c41e;
$toggleTabColor: white;
$toggleBorder: #898989;

.progressdialog-container {
	position: fixed;
	width: 100%;
	z-index: 1500;
}

.backdrop {
	height: 100vh;
	backdrop-filter: blur(5px);
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
    bottom: 0px;
    top: 0px;
    z-index: 150;
    width: 100%;
}

.navbar {
	display: flex;
	flex-direction: column;
	// background: $progressDialogFoldContentColor;
	color: $subColor;
	font-size: $fontSize;
	border-bottom-left-radius: 45px;
	border-bottom-right-radius: 45px;
}

.expand {
	height: 87vh;
}

.cube-btn-outline::after {
	border: none !important;
}

.receiver-code-btn {
	color: lightgrey !important;
	font-weight: bold;
	font-size: $h4 !important;
}

.fold {
	height: 4.5rem;
}

.flex-between {
	display: flex;
	justify-content: space-between;
}

.flex-center {
	display: flex;
	justify-content: center;
}

.navbar .title {
	margin: 0.5rem 0rem;
	text-align: center;
	color: $progressDialogHighlightTextColor;
	font-weight: bold;
	font-size: $h2;
	position: relative;
}

.title {
	margin: 0.5rem 0rem;
	text-align: center;
	color: $progressDialogHighlightTextColor;
	font-weight: bold;
	font-size: $h2;
	position: relative;
}
.order-count {
	position: absolute;
	margin-left: 1rem;
	bottom: 0.1rem;
}
.subtitle {
	text-align: center;
	font-weight: bold;
	font-size: $h3;
	color: $subColor;
}
.navbar .title .order-count {
	position: absolute;
	margin-left: 1rem;
	bottom: 0.1rem;
}

.navbar .subtitle {
	text-align: center;
	font-weight: bold;
	font-size: $h3;
}

.navbar .slider {
	padding: 0.3rem 1rem;
	font-size: $h4;
	margin-top: 2.4rem;
}

.navbar .navbar-content {
	flex: 1 1 auto;
	padding: 0.5rem 1rem;
	line-height: 2;
}

@media only screen and (min-height: 0px) and (max-height: 640px) {
	.navbar .navbar-content {
		overflow-y: scroll;
	}
}

.navbar-content .header {
	font-size: $h5;
	border: 1px solid #898989;
	width: 100%;
	text-align: center;
}

.navbar-content .order-description {
	padding: 0rem 0.5rem;
    margin-top: 6px;
}

.address-detail .left,
.center {
	margin: 0rem 0.5rem;
}

.address-detail .right {
	margin-left: 0.5rem;
}

.order-detail {
	padding: 0rem 0.5rem;
	height: 20vh;
	overflow-y: scroll;
}
@media only screen and (min-height: 414px) and (max-height: 736px) {
	.order-detail {
		height: 14vh;
	}
}
@media only screen and (min-height: 812px) and (max-height: 1024px) {
	.order-detail {
		height: 22vh;
	}
}

.navbar .chatroom {
	overflow-y: unset;
	margin-top: 3rem;
}

.progressbar {
	height: 10vh;
	margin: 0rem 2rem;
}

.delivery-time {
	font-size: $h4;
	color: $progressDialogHighlightTextColor;
}

.matching-tips {
	font-size: $h4;
	margin: 0.5rem 0;
	color: white;
}

.pickup-code {
	font-size: $h4;
	margin-bottom: 1.5rem;
	color: $subColor;
}

.navbar .footer {
	margin: 0.2rem 2rem;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
}

.footer .icon {
	font-size: 1.2rem;
}

.footer .progress-dialog-toggle {
	background: $toggleTabColor;
	border: 1px solid $toggleBorder;
	width: 85px;
	height: 0.55rem;
	border-radius: 25px;
	margin-left: 10px;
	display: flex;
    justify-content: center;
    align-items: center;
}
.trans {
	overflow: hidden;
    width: 100%;
    display: block;
    transition: all 0.4s ease-out;
    transform: translateY(-75vh);
    background: linear-gradient(#282828, #595757);
    position: fixed;
    z-index: 1000;
	height: 87vh;
	border-bottom-left-radius: 45px;
    border-bottom-right-radius: 45px;
}
.footer {
	position: absolute;
    bottom: 0px;
    width: 100%;
   	padding: 0.2rem 0rem;
	display: flex;
	justify-content: space-around;
	align-items: flex-end;
}
.title_section {
	position: fixed;
	top: 0px;
	z-index: 999999999;
	width: 100%;
}
.deliver_section {
	position: absolute;
    width: 100%;
    bottom: 22px;
}
.rotate {
    transform: rotate(180deg);
}
</style>
